"use client";

import "./LogoMarqueeSection.scss";
import { Container } from "react-bootstrap";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const LogoMarqueeSection = ({
  title = "Loved by Millions of Users",
  brands = [],
}) => {
  return (
    <section className="logo-marquee-section">
      <Container fluid>
        <h2 className="logo-marquee-title">{title}</h2>

        <div className="logo-marquee-wrapper">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={40}
            slidesPerView={6}
            loop
            speed={3000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            allowTouchMove={false}
            breakpoints={{
              320: { slidesPerView: 3 },
              768: { slidesPerView: 5 },
              992: { slidesPerView: 7 },
            }}
          >
            {brands.map((brand, index) => (
              <SwiperSlide key={index} className="logo-marquee-slide">
                <Image
                  src={brand.src}
                  alt={brand.alt}
                  className="logo-marquee-logo"
                  width={150}
                  height={80}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>
    </section>
  );
};

export default LogoMarqueeSection;